const updateHighlightsPlaylist = (state = {}, action) => {
    const { datasource, data = {} } = action;

    if (datasource === 'contentGraph') {
        const { videoContent: videos = []} = data?.data || {};
        const newData = {
            videos
        };

        return Object.assign({}, state, newData);
    }

    if (datasource === 'content') {
        const { videos = [] } = data?.data || {};
        const newData = {
            videos
        };
        return Object.assign({}, state, newData);
    }

    return state;
};

export default updateHighlightsPlaylist;
